import type { FC, PropsWithChildren } from 'react';

import { useIsDesktopDisplay } from './ViewJobDisplayContext';

export function useIsMobile() {
    return !useIsDesktop();
}

export function useIsDesktop() {
    return useIsDesktopDisplay();
}

const DesktopOnly: FC<PropsWithChildren> = ({ children }) => {
    return useIsDesktop() ? <>{children}</> : null;
};

const MobileOnly: FC<PropsWithChildren> = ({ children }) => {
    return useIsMobile() ? <>{children}</> : null;
};

export const ScreenDisplay = {
    MobileOnly,
    DesktopOnly,
};
